/**
 * Strings da abertura eletrônica por CCB declarada (GUS-253, ADR-0130; HTML 6.8 por CCB). Valem as
 * regras do `pt-BR.ts`: nenhum termo técnico interno.
 *
 * - `abertura.contratosDigitais` (E177.F4): a tela 2 do Contrato Digital — um bloco por CCB, o número
 *   antes dos arquivos e os vínculos explícitos.
 * - `abertura.conferirPorCcb` (E177.F5): o Conferir e o Acompanhar por CCB — as contagens, os
 *   documentos por CCB e o conflito com o identificador do pacote.
 */
export const ptBRContratosDigitais = {
  titulo: 'Contratos digitais',
  subtitulo:
    'Uma CCB por bloco. Cada CCB gera seu próprio caso, exame e laudo dentro da mesma pasta e do mesmo processo.',
  cardTitulo: 'Processo e CCBs',
  processo: 'Processo (define a pasta)',
  pasta: 'Pasta do banco',
  naoInformado: 'Não informado',
  naoInformada: 'Não informada',
  quantas: 'CCBs neste envio',
  quantasAjuda:
    'Informe o número da CCB antes de selecionar os arquivos dela: o ZIP do pacote ou os arquivos individuais, mais comprovante de depósito e documento de identidade da operação.',
  quantasMinimo: 'Remova os arquivos e o número das CCBs que deseja excluir.',
  bloco: 'CCB {i} de {n}',
  numero: 'Número da CCB',
  numeroPlaceholder: 'Nº a informar',
  repetido: 'Este número já foi informado em outro bloco.',
  erroAoGravar: 'Não foi possível gravar o número. Tente novamente.',
  numeroVazio: 'Informe o número desta CCB.',
  removerCcb: 'Remover esta CCB',
  soltar: 'Arraste o pacote da CCB ou selecione os arquivos',
  soltarAjuda:
    'ZIP da CCB ou arquivos individuais, mais comprovante de depósito e documento de identidade desta operação',
  selecionar: 'Selecionar documentos da {ccb}',
  informeONumero: 'Informe o número da CCB para liberar o envio dos arquivos.',
  nenhumArquivo: 'Nenhum arquivo nesta CCB.',
  enviando: 'Enviando · {p}%',
  falhou: 'Não foi possível receber o arquivo',
  recebido: 'Recebido · integridade registrada no recibo',
  // E216.F7 (GUS-317 item 9): os mesmos bytes de um arquivo do caso não entram de novo.
  jaRecebido:
    'Já recebido · idêntico a um arquivo do caso, não foi duplicado; a tentativa fica no recibo',
  tentarDeNovo: 'Tentar novamente',
  remover: 'Remover',
  // E177.F4.C02 (F-E177.F4-02): abrir o arquivo recebido antes do vínculo; o homônimo se distingue.
  abrir: 'Abrir',
  abrirArquivo: 'Abrir {arquivo} para conferir o conteúdo',
  erroAoAbrir: 'Não foi possível abrir o arquivo. Tente novamente.',
  homonimo: '{nome} · arquivo {id}',
  erroAoRemover: 'Não foi possível remover. Tente novamente.',
  compartilhadoCom: 'Compartilhado · {ccbs}',
  compartilhadoDe: 'Compartilhado · enviado na {ccb}',
  // E177.F3.C03 (GUS-253 itens 5 e 6): a cópia recebida aqui com outro nome diz o da origem.
  compartilhadoDeComNome: 'Compartilhado · mesmo conteúdo de {nome}, enviado na {ccb}',
  vinculadoAqui: 'Vinculado a esta CCB',
  vincularAOutras: 'Vincular a outras CCBs',
  editarVinculos: 'Editar vínculos',
  desvincular: 'Desvincular desta CCB',
  aplicarA: 'Aplicar {arquivo} a',
  aplicarAjuda: 'Marque somente as CCBs a que este documento se refere.',
  origemDoEnvio: '{ccb} · origem do envio',
  confirmarVinculos: 'Confirmar vínculos',
  cancelar: 'Cancelar',
  erroAoVincular: 'Não foi possível gravar os vínculos. Tente novamente.',
  vincularJaEnviado: 'Vincular documento já enviado em outra CCB',
  jaEnviados: 'Documentos enviados em outras CCBs',
  todosVinculados: 'Todos os documentos das outras CCBs já estão vinculados aqui.',
  adicionar: 'Adicionar outra CCB',
  comoTrataTitulo: 'Como o sistema trata',
  comoTrataTexto:
    '1 processo = 1 pasta. Dentro da pasta, cada CCB gera um caso, um exame e um laudo próprios. O mesmo arquivo enviado em mais de uma CCB da pasta é compartilhado sozinho, pelo conteúdo; vincule o que vale para outra CCB e não foi enviado nela.',
  aguardando: 'Aguardando o envio de {n} arquivo(s). Você já pode cadastrar a próxima CCB.',
  comFalha: '{n} arquivo(s) com falha. Tente novamente ou remova para conferir.',
  comArquivoSemCcb: 'Há arquivos sem CCB. Vincule cada um a uma CCB ou remova para conferir.',
  // E209.F3.T02 (GUS-296 item 12a): soltos com o número digitado, antes de ele estar gravado.
  esperandoONumero: '{n} arquivo(s) aguardando o número da CCB ser gravado para o envio.',
  faltaNumero: 'Informe o número de cada CCB para conferir.',
  numeroPendente:
    'Há número de CCB alterado e ainda não gravado. Confirme com Enter ou saindo do campo para conferir.',
  faltaArquivo:
    'Cada CCB precisa de ao menos um arquivo, enviado nela ou vinculado a ela, para conferir.',
  semCcbTitulo: 'Arquivos sem CCB',
  semCcbTexto: 'Enviados antes das CCBs. Vincule cada um à CCB a que pertence, ou remova.',
  // E209.F3.T03 (GUS-296 item 12b): uma ação por CCB gravada, para todos os arquivos sem CCB.
  vincularTodos: 'Vincular os {n} arquivos à {ccb}',
  rotulo: 'CCB {numero}',
  rotuloSemNumero: 'CCB {n} (sem número)',
  carregando: 'Carregando os contratos do envio…',
  erroAoCarregar: 'Não foi possível carregar os contratos do envio. Tente novamente.',
  voltar: 'Voltar',
};

export const ptBRConferirPorCcb = {
  documentoUm: '1 documento',
  documentos: '{n} documentos',
  compartilhadoUm: '1 compartilhado',
  compartilhados: '{n} compartilhados',
  divergente: 'identificador do pacote divergente',
  divergenteMantido: 'número informado mantido com pendência para a equipe; o pacote indica {lido}',
  // E177.F5.C01 (GUS-253 item 4): a linha do caso no Acompanhar.
  divergenteNoRecibo: 'número informado mantido; o pacote indica {fonte} {lido}',
  grupo: '{ccb} · {documentos}',
  gruposTitulo: 'Documentos por CCB',
  somenteEsta: 'Somente esta CCB',
  compartilhadoCom: 'Compartilhado com {ccbs}',
  enviadoNa: 'Compartilhado · enviado na {ccb}',
  enviadoNaComNome: 'Compartilhado · mesmo conteúdo de {nome}, enviado na {ccb}',
  vinculadoAqui: 'Vinculado a esta CCB',
  recebido: 'Recebido',
  editar: 'Editar documentos e vínculos',
  verIdentificacao: 'Ver identificação',
  conflitoTitulo: '{ccb}: o pacote indica a CCB {lido}',
  conflitoTexto:
    'O número informado e o identificador encontrado no pacote não coincidem. Nada foi reatribuído. Corrija o número da CCB ou mantenha o informado e registre a pendência para a equipe.',
  conflitoFonte: 'Lido no pacote: {fonte} {valor}',
  corrigir: 'Corrigir número da CCB',
  manter: 'Manter {ccb} e registrar pendência',
  mantendo: 'Registrando…',
  erroAoManter: 'Não foi possível registrar a pendência. Tente novamente.',
  erroSemArquivo:
    'Há CCB sem arquivo enviado nela nem vinculado a ela. Volte aos contratos e envie ou vincule os arquivos de cada CCB.',
  erroDivergente:
    'Há CCB com o identificador do pacote divergente. Corrija o número ou mantenha o informado.',
  // E177.F6 (HTML 6.8 por CCB `?tela=complemento-ccb`): o complemento com destino por CCB.
  complemento: {
    legenda: 'A quais CCBs estes documentos se referem?',
    esteCaso: 'CCB {ccb} · este caso',
    esteCasoSemCcb: 'Este caso',
    irma: 'CCB {ccb} · mesma pasta e processo',
    ajuda: 'O vínculo é registrado por CCB. Versões já emitidas não são alteradas.',
    encaminhando: 'Enviando também para {ccbs}…',
    encaminhado: 'Também enviado para {ccbs}.',
    falhou: 'Não foi possível enviar para {ccbs}. Os documentos ficaram neste caso.',
    tentarDeNovo: 'Tentar novamente',
    erroAoCarregar: 'Não foi possível carregar as CCBs da mesma pasta. O envio fica só neste caso.',
  },
  // E177.F6 (HTML 6.8 por CCB `?tela=interno-envio-ccb`): a mesa do caso da CCB.
  mesa: {
    cabecalho: 'CCB {ccb} · {contagens}',
    nota: 'Somente documentos vinculados a esta CCB na abertura ou na complementação aparecem aqui. Documentos de outras CCBs da mesma pasta não entram no exame.',
    compartilhado: 'Compartilhado',
    compartilhadoCom: 'Os mesmos arquivos estão no caso da {ccbs}, da mesma pasta.',
    divergenciaTitulo: 'Pendência da abertura: CCB {numero} mantida com o identificador divergente',
    divergenciaTexto:
      'O pacote indica {fonte} {lido}. Quem enviou manteve o número informado: confira antes de concluir o exame.',
  },
};
